import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { problems } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-petrol py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-247" data-mp="30h7kvn5mjqti">
      <div className="mx-auto max-w-4xl px-4" data-id="element-248" data-mp="30jam73c896dj">
        <div className="text-center" data-id="element-249" data-mp="2vq7n6fool4py">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-aqua" data-id="element-250" data-mp="2vp6eghv50ube">La realidad docente</p>
          <h2 id="problem-title" className="mx-auto mt-3 max-w-3xl text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-251" data-mp="39jyyntlz2yob">
            ¿Cuántas clases más vas a preparar sobre Instrumentación Quirúrgica sin tener el material correcto?
          </h2>
          <p className="mx-auto mt-5 max-w-3xl leading-relaxed text-mutedDark" data-id="element-252" data-mp="3eia8438cv760">
            Buscás información en internet que no tiene secuencia didáctica ni menciona Argentina. Armás planificaciones desde
            cero cada ciclo lectivo. Y cuando un alumno pregunta sobre el Checklist OMS, el Marco de Referencia del INET 2026 o
            cómo se organiza el conteo quirúrgico en una cesárea de urgencia, no tenés una respuesta que los enganche con la
            realidad del quirófano argentino.
          </p>
          <p className="mt-4 font-bold text-aqua" data-id="element-253" data-mp="scid9l8a0iav">No es falta de vocación docente. Es que nadie armó el sistema completo para vos.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.42
      }} className="mt-9 rounded-2xl border border-alert/45 bg-petrolDark p-6 sm:p-8" data-id="element-254" data-mp="1244lr9t8c39x">
          <p className="mb-5 font-display text-xl font-bold text-[#F0A9A3]" data-id="element-255" data-mp="1g3e2qbp9f1ey">Esto te está pasando ahora mismo:</p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-256" data-mp="3dtnni225cr3z">
            {problems.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-onDark" data-id="element-257" data-mp="3huh9gpw13vu8">
                <span className="mt-0.5 rounded-full bg-alert/20 p-1" data-id="element-258" data-mp="p092twifdih6">
                  <XIcon className="h-3.5 w-3.5 text-[#F0A9A3]" data-id="element-259" data-mp="p2d2g29ajvbn" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>

        <p className="mt-8 text-center font-bold text-aqua" data-id="element-260" data-mp="y1qhdag6pc3r">
          ¿Y si esta fuera la última semana que enseñás Instrumentación Quirúrgica sin tener todo resuelto?
        </p>
      </div>
    </section>;
}